import { render, staticRenderFns } from "./LiveAccountDetails.vue?vue&type=template&id=275fc77e"
import script from "./LiveAccountDetails.vue?vue&type=script&lang=js"
export * from "./LiveAccountDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports